export var ConnectorStatus;
(function (ConnectorStatus) {
    ConnectorStatus["CONNECTOR_STATUS_ACTIVE"] = "ACTIVE";
    ConnectorStatus["CONNECTOR_STATUS_INACTIVE"] = "INACTIVE";
})(ConnectorStatus || (ConnectorStatus = {}));
